import React from "react";

export default React.memo(function RewardsFAQ() {
  return (
    <section className="pt-7 pb-12">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-12 col-lg-10 col-xl-8">
            <h3 className="mb-10 text-center">Frequently Asked Questions</h3>

            <ul className="list-group list-group-flush-x mb-9" id="rewards-faq">
              <li className="list-group-item">
                <a
                  className="dropdown-toggle d-block font-size-lg font-weight-bold text-reset"
                  data-toggle="collapse"
                  href="#rewards-faq-1"
                >
                  I am not a subscriber, can I still be part of the Loyalty
                  Program?
                </a>

                <div
                  className="collapse"
                  id="rewards-faq-1"
                  data-parent="#rewards-faq"
                >
                  <div className="mt-5">
                    <p className="mb-0 font-size-lg text-gray-500">
                      Yes! Everyone with a Chic Beauty Box account is part of
                      our Loyalty Program, and can begin earning points by
                      either spending in our shop, referring a friend, or
                      leaving product reviews.
                    </p>
                  </div>
                </div>
              </li>
              <li className="list-group-item">
                <a
                  className="dropdown-toggle d-block font-size-lg font-weight-bold text-reset"
                  data-toggle="collapse"
                  href="#rewards-faq-2"
                >
                  How do I spend my Loyalty Points?
                </a>

                <div
                  className="collapse"
                  id="rewards-faq-2"
                  data-parent="#rewards-faq"
                >
                  <div className="mt-5">
                    <p className="font-size-lg text-gray-500">
                      Loyalty Points are only valid for orders placed in the
                      shop. Loyalty Points cannot be used toward rebillable
                      subscriptions. 10 points = $1 to spend.
                    </p>
                    <p className="mb-0 font-size-lg text-gray-500">
                      Loyalty Points will be a payment method at checkout. If
                      you have redeemable points, select that option at checkout
                      to use your available points.
                    </p>
                  </div>
                </div>
              </li>
              <li className="list-group-item">
                <a
                  className="dropdown-toggle d-block font-size-lg font-weight-bold text-reset"
                  data-toggle="collapse"
                  href="#rewards-faq-3"
                >
                  Do my Loyalty Points expire?
                </a>

                <div
                  className="collapse"
                  id="rewards-faq-3"
                  data-parent="#rewards-faq"
                >
                  <div className="mt-5">
                    <p className="mb-0 font-size-lg text-gray-500">
                      Loyalty Points do not expire. However, there's a
                      reasonable expectation that they are to be used up within
                      one year from the date they are first earned.
                    </p>
                  </div>
                </div>
              </li>
              <li className="list-group-item">
                <a
                  className="dropdown-toggle d-block font-size-lg font-weight-bold text-reset"
                  data-toggle="collapse"
                  href="#rewards-faq-4"
                >
                  Can I redeem my Loyalty Points for cash?
                </a>

                <div
                  className="collapse"
                  id="rewards-faq-4"
                  data-parent="#rewards-faq"
                >
                  <div className="mt-5">
                    <p className="mb-0 font-size-lg text-gray-500">
                      Loyalty Points are not redeembale for cash. Also, you
                      cannot redeem Loyalty Points for more than the total
                      amount of your purchase.
                    </p>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
});
